import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import {
    Box,
    Button,
    Typography,
    MenuItem,
    Menu,
    Chip,
    IconButton,
    Divider,
    Skeleton,
    TextareaAutosize,
    FormHelperText,
    Card,
    CardContent,
    CardHeader,
    Stack,
    Alert,
    AlertTitle,
} from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { config, styles } from "../../style";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PostAddIcon from "@mui/icons-material/PostAdd";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AddCommentIcon from "@mui/icons-material/AddComment";
import CheckIcon from "@mui/icons-material/Check";
import DvrIcon from "@mui/icons-material/Dvr";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import { useAuth } from "../../hooks/useAuth";
import { CheckCircleOutlineOutlined, Info, KeyboardArrowDown } from "@mui/icons-material";
import Modal2 from "../../components/Modal/Modal2";
import CommentEditIcon from "../../icons/CommentEditIcon";
import { Comments } from "./comments";
import { useDispatch } from "react-redux";
import { saveNotesAsync } from "./speakerSearchSlice";
import { Speaker } from "../Speaker";
import { Modal } from "../../components/Modal";
import TextToggle from "../../components/TextToggle";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { format } from "date-fns";
import RequestFeeFormModal from "./RequestFeeFormModal";

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: theme.palette.mode === "light" ? "rgb(55, 65, 81)" : theme.palette.grey[300],
        boxShadow:
            "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
        "& .MuiMenu-list": {
            padding: "4px 0",
        },
        "& .MuiMenuItem-root": {
            "& .MuiSvgIcon-root": {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            "&:active": {
                backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            },
        },
    },
}));

export const SpeakerCard = (props) => {
    const {
        record,
        speakerLists,
        listBySpeaker,
        commentBySpeaker,
        noteBySpeaker,
        availabilityCheck,
        availabilityCheckStart,
        availabilityCheckEnd,
        commentsList,
        setCommentsList,
        filterItems = [],
        isBureau,
        countryPicklist,
    } = props;
    const dispatch = useDispatch();
    const [saveAnchorEl, setSaveAnchorEl] = React.useState(null);
    const [otherAnchorEl, setOtherAnchorEl] = React.useState(null);
    const saveOption = Boolean(saveAnchorEl);
    const otherOption = Boolean(otherAnchorEl);
    const { getUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();

    const [openCommentModal, setOpenCommentModal] = useState(false);
    const [editCommentModalOpen, setEditCommentModalOpen] = useState(false);
    const [openSpeakerScreen, setOpenSpeakerScreen] = useState(false);
    const [selectedSpeaker, setSelectedSpeaker] = useState({});

    const [commentValue, setCommentValue] = useState("");
    const [selectedComment, setSelectedComment] = useState("");

    const [showCommentError, setShowCommentError] = useState("");

    const [openRequestFeeModal, setOpenRequestFeeModal] = useState(false);

    const [speakerSearchSelectedTeb, setSpeakerSearchSelectedTeb] = useState("");

    const availabilityCheckGivenDateTimestamp = availabilityCheck
        ? new Date(availabilityCheck).getTime() + availabilityCheck.utcOffset() * 60 * 1000
        : 0;
    const availabilityCheckGivenDateTimestampStart = availabilityCheckStart
        ? new Date(availabilityCheckStart).getTime() + availabilityCheckStart.utcOffset() * 60 * 1000
        : 0;

    const availabilityCheckGivenDateTimestampEnd = availabilityCheckEnd
        ? new Date(availabilityCheckEnd).getTime() + availabilityCheckEnd.utcOffset() * 60 * 1000
        : 0;

    const promotionalTitleRef = React.useRef();

    const promotionalTitleNewRef = React.useRef();
    const shortBioRef = React.useRef();
    const coBrokerProposalLanguageRef = React.useRef();

    const getImageURL = () => {
        return record?.speakerPortalImage ? record?.speakerPortalImage : record?.speakerImagePublicURL;
    };

    const handleSaveMenuClick = (event) => {
        setSaveAnchorEl(event.currentTarget);
    };

    const handleOpenCommentModal = (event) => {
        // event.stopPropagation();
        // const detail = event.detail;

        setSelectedComment("");
        setCommentValue("");
        setOpenCommentModal(true);
        setOtherAnchorEl(null);
    };
    const handleCloseCommentModal = (event) => {
        setOpenCommentModal(false);
        setShowCommentError("");
    };

    const handleEditCommentModalOpen = (comment) => {
        // event.stopPropagation();
        // const detail = event.detail;
        setSelectedComment(comment);
        setCommentValue(comment.description);
        setEditCommentModalOpen(true);
    };
    const handleEditCommentModalClose = (event) => {
        setEditCommentModalOpen(false);
        setShowCommentError("");
    };

    const handleCommentSave = () => {
        if (commentValue) {
            setShowCommentError("");

            const newComment = {
                id: "",
                description: commentValue,
                speakerId: record.Id,
                contactId: userDetails?.contact?.id,
                contactName: userDetails?.contact?.name,
            };
            dispatch(saveNotesAsync({ note: newComment }));

            setOpenCommentModal(false);
        } else {
            setShowCommentError("Please enter your comment.");
        }
    };
    const handleDeleteComment = (comment) => {
        let commentToDelete = comment?.id ? { ...comment } : { ...selectedComment };
        if (commentToDelete) {
            commentToDelete.isArchived = true;
            dispatch(saveNotesAsync({ note: commentToDelete }));
            setEditCommentModalOpen(false);
            setOpenCommentModal(false);
        }
    };
    const handleSaveChangeComment = () => {
        if (commentValue) {
            let newComment = { ...selectedComment };
            newComment.description = commentValue;
            dispatch(saveNotesAsync({ note: newComment }));
            setEditCommentModalOpen(false);
            setOpenCommentModal(false);
            setShowCommentError("");
        } else {
            setShowCommentError("Please enter your comment.");
        }
    };

    const handleSaveMenuClose = (filterValue, value) => {
        if (filterValue) {
            if (filterValue === "create-list") {
                const createEvent = new CustomEvent("create", {
                    detail: {
                        value: record,
                    },
                });
                document.dispatchEvent(createEvent);
            }
            if (filterValue === "add-speaker") {
                if (alreadyExistInList(value)) {
                    const createEvent = new CustomEvent("removeSpeaker", {
                        detail: {
                            value: record,
                            listId: value,
                        },
                    });
                    document.dispatchEvent(createEvent);
                } else {
                    const createEvent = new CustomEvent("addSpeaker", {
                        detail: {
                            value: record,
                            listId: value,
                        },
                    });
                    document.dispatchEvent(createEvent);
                }
            }
        }
        setSaveAnchorEl(null);
    };

    const handleOtherMenuClick = (event) => {
        setOtherAnchorEl(event.currentTarget);
    };

    const handleOtherMenuClose = (filterValue) => {
        if (filterValue === "leave-comment") {
            handleOpenComment(record.Id);
        } else if (filterValue === "view-profile") {
            // const createEvent = new CustomEvent("viewProfile", {
            //     detail: {
            //         value: record,
            //     },
            // });
            // document.dispatchEvent(createEvent);
            displaySpeakerScreen(record);
        } else if (filterValue === "leave-note") {
            const createEvent = new CustomEvent("leaveNote", {
                detail: {
                    value: record,
                    note: getNote(),
                },
            });
            document.dispatchEvent(createEvent);
        }
        setOtherAnchorEl(null);
    };

    const displaySpeakerScreen = (record) => {
        setSelectedSpeaker(record);
        setOpenSpeakerScreen(true);
    };

    const mainCategoryRef = React.useRef();

    const getCategory = () => {
        if (record?.mainCategory) {
            const mainCategoryData = filterItems?.find((cItem) => cItem.attribute === "mainCategory");

            let newCategory = [];
            for (let index = 0; index < mainCategoryData?.refinements?.length; index++) {
                const cFilter = mainCategoryData?.refinements?.[index]?.value;

                if (record?.mainCategory?.includes(cFilter)) {
                    newCategory.push(cFilter);
                }
            }

            return (
                <span
                    ref={mainCategoryRef}
                    style={{
                        color: "#444CE7",
                    }}>
                    {
                        <TextToggle
                            parentRef={promotionalTitleRef}
                            text={newCategory?.join(", ")}
                            maxLines={3}></TextToggle>
                    }
                </span>
            );
        }
        return <></>;
    };

    const getListCount = (speakerId) => {
        return listBySpeaker && listBySpeaker[speakerId] ? listBySpeaker[speakerId].length : 0;
    };

    const alreadyExistInList = (listId) => {
        return listBySpeaker && listBySpeaker[record.Id] && listBySpeaker[record.Id].indexOf(listId) > -1
            ? true
            : false;
    };

    const handleOpenComment = (recordId) => {
        const event = new CustomEvent("openDrawer", {
            detail: { parentId: recordId, parentName: record.Name },
        });
        document.dispatchEvent(event);

        // const event = new CustomEvent("openCommentModal", {
        //     detail: { parentId: recordId, parentName: record.Name },
        // });
        // document.dispatchEvent(event);
    };

    // const handleOpenEditComment = (recordId) => {
    //     const event = new CustomEvent("openEditCommentModal", {
    //         detail: { parentId: recordId, parentName: record.Name },
    //     });
    //     document.dispatchEvent(event);
    // };

    const getCommentCount = () => {
        return commentBySpeaker && commentBySpeaker[record.Id] ? commentBySpeaker[record.Id].length : 0;
    };

    const getNote = () => {
        return noteBySpeaker && noteBySpeaker[record.Id] ? noteBySpeaker[record.Id] : undefined;
    };

    const handleEditNote = () => {
        const createEvent = new CustomEvent("leaveNote", {
            detail: {
                value: record,
                note: getNote(),
            },
        });
        document.dispatchEvent(createEvent);
    };

    const isEventWithinDateRange = (event, startDate, endDate) => {
        // Convert range dates to Date objects
        const rangeStartDate = new Date(startDate);
        const rangeEndDate = new Date(endDate);

        // Handle cases where the event might not have a start or end date
        let eventStartDate = event.startDate ? new Date(event.startDate) : null;
        let eventEndDate = event.endDate ? new Date(event.endDate) : null;

        // If event has no start date, assume it starts at the range start date
        if (!eventStartDate) {
            eventStartDate = rangeStartDate;
        }

        // If event has no end date, assume it ends at the range end date
        if (!eventEndDate) {
            eventEndDate = rangeEndDate;
        }

        // Check if the event's start or end date is within the range
        return (
            (eventStartDate >= rangeStartDate && eventStartDate <= rangeEndDate) ||
            (eventEndDate >= rangeStartDate && eventEndDate <= rangeEndDate) ||
            (eventStartDate <= rangeStartDate && eventEndDate >= rangeEndDate)
        );
    };

    const formatDate = (date) => {
        if (!date) return "";

        const parts = date.split("-");
        if (parts.length === 3) {
            return `${parts[1]}/${parts[2]}/${parts[0]}`;
        }
        return "";
    };

    const getDateISONoTime = (dateTime) => {
        let dateNoTime;
        const padd = (num) => num.toString().padStart(2, "0");

        if (!dateTime) {
            dateNoTime = new Date();
        }
        if (Object.prototype.toString.call(dateTime) !== "[object Date]") {
            dateNoTime = new Date();
        }

        dateNoTime = dateNoTime || dateTime;
        dateNoTime = new Date(dateNoTime.getTime());
        dateNoTime.setHours(0, 0, 0, 0);

        return [dateNoTime.getFullYear(), padd(dateNoTime.getMonth() + 1), padd(dateNoTime.getDate())].join("-");
    };

    const getDateNoTime = (dateTime) => {
        var date = new Date(dateTime.getTime());
        date.setHours(0, 0, 0, 0);
        return date;
    };

    const getDateNoTimeFromISO = (dateTime) => {
        if (!dateTime) return new Date();
        dateTime = dateTime.toISOString();
        const parts = dateTime.split("-");
        if (parts.length !== 3) return new Date();

        return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    };

    const getAvailability = () => {
        console.log(new Date(availabilityCheckStart));
        console.log(availabilityCheckStart);
        if (availabilityCheckGivenDateTimestampStart > 0 && record?.calendarEntries?.length > 0) {
            let find = record.calendarEntries.find((item) => {
                if (item.startDateTimestanp > 0 && item.endDateTimestanp > 0) {
                    return (
                        availabilityCheckGivenDateTimestampStart >=
                            Math.min(item.startDateTimestanp, item.endDateTimestanp) &&
                        availabilityCheckGivenDateTimestampStart <=
                            Math.max(item.startDateTimestanp, item.endDateTimestanp)
                    );
                } else if (item.startDateTimestanp > 0) {
                    return availabilityCheckGivenDateTimestampStart === item.startDateTimestanp;
                } else if (item.endDateTimestanp > 0) {
                    return availabilityCheckGivenDateTimestampStart === item.endDateTimestanp;
                }
                return false;
            });

            if (find) {
                if (find.type === "BOOKED" || find.type === "PRE-RECORDING") return "BOOKED";
                return "HOLD";
            }
            return false;
        }
        return true;
    };

    const getSpeakerAvailability = () => {
        if (availabilityCheckGivenDateTimestampEnd && availabilityCheckGivenDateTimestampStart) {
            let dateRange = getDatesRange(
                new Date(availabilityCheckGivenDateTimestampStart),
                new Date(availabilityCheckGivenDateTimestampEnd)
            );

            let filtersRecord = record.calendarEntries.filter((item) => {
                if (availabilityCheckGivenDateTimestampEnd && availabilityCheckGivenDateTimestampStart) {
                    return isEventWithinDateRange(
                        item,
                        availabilityCheckGivenDateTimestampStart,
                        availabilityCheckGivenDateTimestampEnd
                    );
                }

                return false;
            });

            if (dateRange?.length > 5) {
                return "";
            }

            let isAvailableForAllDays = !filtersRecord || filtersRecord.length === 0;
            let speakerAvailability = {
                ...record,
                isAvailableForAllDays: isAvailableForAllDays,
                availability: !isAvailableForAllDays
                    ? getAvailabilityData(mapCalendarEvents(filtersRecord), dateRange, record.id)
                    : { dates: [] },
            };

            console.log(speakerAvailability);

            if (speakerAvailability.isAvailableForAllDays) {
                return (
                    <>
                        <Typography
                            sx={{
                                color: "#344054",
                                fontSize: "14px",
                                fontWeight: 600,
                                marginBottom: "4px",
                                marginTop: "4px",
                            }}>
                            Availability
                        </Typography>
                        <Tooltip title="Tentatively available for selected dates">
                            <Chip
                                variant="outlined"
                                label={"Tentatively available for selected dates"}
                                color="success"
                            />
                        </Tooltip>
                    </>
                );
            } else {
                let notBooked = speakerAvailability.availability.dates.find((item) => {
                    return !item.booked;
                });
                if (!notBooked) {
                    return (
                        <>
                            <Typography
                                sx={{
                                    color: "#344054",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    marginBottom: "4px",
                                    marginTop: "4px",
                                }}>
                                Availability
                            </Typography>
                            <Tooltip title="Conflict exists for your selected dates">
                                <Chip
                                    variant="outlined"
                                    label={"Conflict exists for your selected dates"}
                                    color="error"
                                />
                            </Tooltip>
                        </>
                    );
                }

                return (
                    <>
                        <Typography
                            sx={{
                                color: "#344054",
                                fontSize: "14px",
                                fontWeight: 600,
                                marginBottom: "4px",
                                marginTop: "4px",
                            }}>
                            Availability
                        </Typography>
                        <Stack direction="row" sx={{ flexWrap: "wrap" }}>
                            {speakerAvailability.availability.dates.map((item) => (
                                <Tooltip
                                    title={
                                        item.available
                                            ? "Tentatively Available"
                                            : item.booked
                                            ? "Existing Conflict"
                                            : item.wait
                                            ? "Potential Conflict"
                                            : "Tentatively Available"
                                    }>
                                    <Chip
                                        variant="outlined"
                                        sx={{ mt: "0.5rem", mr: "0.2rem" }}
                                        label={format(item.date, "MMM dd, yyyy")}
                                        color={
                                            item.available
                                                ? "success"
                                                : item.booked
                                                ? "error"
                                                : item.wait
                                                ? "warning"
                                                : "success"
                                        }
                                    />
                                </Tooltip>
                            ))}
                        </Stack>
                    </>
                );
            }
        }
    };

    const mapCalendarEvents = (events) => {
        if (!events) return [];

        return events.map((item) => {
            return {
                id: item.id,
                name: item.name,
                start: new Date(item.startDate),
                end: new Date(item.endDate),
                status: item.status,
                type: item.type,
                opportunityId: item.opportunityId,
                opportunity: item.opportunityName,
            };
        });
    };

    const getCalendarAvailability = (calendars, date) => {
        const emptyAvailability = { isAvailable: true, status: "", calendar: null };
        if (!calendars) return emptyAvailability;

        if (calendars.length === 0) return emptyAvailability;

        for (const calendar of calendars) {
            if (date >= getDateNoTimeFromISO(calendar.start) && date <= getDateNoTimeFromISO(calendar.end)) {
                return { isAvailable: false, status: calendar.type, calendar: calendar };
            }
        }

        return emptyAvailability;
    };

    const getAvailabilityData = (calendar, ranges) => {
        return {
            dates: ranges.map((date, i) => {
                const availableInfo = getCalendarAvailability(calendar, date);
                return {
                    key: i,
                    date: date,
                    startDate: availableInfo.calendar?.start,
                    endDate: availableInfo.calendar?.end,
                    name: availableInfo.calendar?.name,
                    url: `/${availableInfo.calendar?.id}`,
                    opportunity: availableInfo.calendar?.opportunity,
                    opportunityUrl: `/${availableInfo.calendar?.opportunityId}`,
                    type: availableInfo.calendar?.type,
                    available: availableInfo.isAvailable,
                    booked: !availableInfo.isAvailable && availableInfo.status === "BOOKED",
                    wait: !availableInfo.isAvailable && availableInfo.status !== "BOOKED",
                };
            }),
        };
    };

    const getDatesRange = (start, end) => {
        if (start && end) {
            let tempDate;
            if (start > end) {
                tempDate = end;
                start = end;
                end = tempDate;
            }
            const range = [];
            const startDate = getDateNoTimeFromISO(start);
            const endDate = getDateNoTimeFromISO(end);
            //const endLoopDate = this.addDays(endDate, 1);
            const addDays = (date, days) => {
                let newDate = new Date(date);
                return new Date(newDate.setDate(newDate.getDate() + days));
            };

            let count = 0;
            let date = null;
            do {
                date = addDays(startDate, count);
                range.push(date);
                count++;
            } while (date < endDate);

            return range;
        } else if (start) {
            return [getDateNoTimeFromISO(start)];
        } else if (end) {
            return [getDateNoTimeFromISO(end)];
        }
        return [];
    };

    const requestFeeModalOpenHandler = () => {
        setOpenRequestFeeModal(true);
    };

    const requestFeeModalCloseHandler = () => {
        setOpenRequestFeeModal(false);
    };

    const stripHtmlTags = (str) => {
        if (!str) return "";

        // This regex will match all HTML tags except <br> and <i>
        return str.replace(/<(?!\/?br\s*\/?|\/?i\s*\/?)[^>]+>/g, "").replaceAll("<br>", "<br><br>");
    };

    useEffect(() => {
        if (selectedComment) {
            setCommentValue(selectedComment.comment);
        }
    }, [selectedComment]);

    const SaveBtnUI = (
        <>
            <Button
                id="filter-speakers"
                aria-controls={saveOption ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={saveOption ? "true" : undefined}
                onClick={handleSaveMenuClick}
                endIcon={<ExpandMoreIcon fontSize="small" sx={{ color: config.primaryColor }} />}
                sx={{
                    ...styles.outlinedButton,
                    height: "33.5px",
                    marginLeft: "10px",
                }}
                variant="outlined">
                {"Add to list"}
            </Button>
            <Menu
                sx={{ width: "300px" }}
                id="basic-menu"
                anchorEl={saveAnchorEl}
                open={saveOption}
                onClose={() => handleSaveMenuClose("")}
                MenuListProps={{
                    "aria-labelledby": "filter-speakers",
                }}>
                <MenuItem onClick={() => handleSaveMenuClose("create-list")} value="create-list">
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                        }}>
                        <PostAddIcon
                            fontSize="small"
                            sx={{
                                color: config.primaryColor,
                                mr: "10px",
                            }}></PostAddIcon>
                        Create speaker list
                    </Box>
                </MenuItem>
                {speakerLists?.length > 0 && (
                    <>
                        <Divider></Divider>
                        {speakerLists.map((item) => (
                            <MenuItem
                                key={item.id}
                                disabled={userDetails.contact?.id !== item.contactId}
                                onClick={() => handleSaveMenuClose("add-speaker", item.id)}
                                value={item.name}
                                className={alreadyExistInList(item.id) ? "selected-list" : ""}>
                                {/* <Grid
                                    container
                                    justifyContent='space-between'
                                    alignItems='center'
                                    sx={{ width: "100%" }}
                                > */}
                                <Box
                                    // item
                                    sx={{
                                        // p: 0,
                                        // whiteSpace: "nowrap",
                                        // overflow: "hidden",
                                        // textOverflow: "ellipsis",
                                        // maxWidth: "150px",
                                        paddingRight: "6.5rem",
                                        width: "100%",
                                    }}>
                                    <Typography
                                        sx={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            maxWidth: "150px",
                                        }}
                                        title={item.name}
                                        // fontSize={"0.875rem"}
                                        // fontWeight={500}
                                        // color={"#101828"}
                                    >
                                        {item.name}
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        position: "absolute",
                                        right: "16px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        p: 0,
                                        fontSize: "12px",
                                        color: alreadyExistInList(item.id) ? "#444CE7" : "#667085",
                                    }}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                        }}>
                                        {item.type === "Private" && (
                                            <Chip
                                                avatar={<CheckCircleOutlineOutlined />}
                                                label="private"
                                                sx={{
                                                    background: "rgba(0,0,0,0.08)",
                                                    padding: "2px 6px",
                                                    fontSize: "10px",
                                                    fontWeight: 500,
                                                    color: "#101828",
                                                    height: "unset",

                                                    marginRight: "0.5rem",

                                                    "& .MuiChip-avatar": {
                                                        width: "10px",
                                                        height: "10px",
                                                        padding: 0,
                                                        margin: 0,
                                                        marginRight: "2px",
                                                    },

                                                    "& .MuiChip-label": {
                                                        padding: 0,
                                                        margin: 0,
                                                    },
                                                }}></Chip>
                                        )}
                                        <span>{item.members.length}</span>
                                        {alreadyExistInList(item.id) ? (
                                            <CheckIcon
                                                fontSize="16px"
                                                sx={{
                                                    ml: "8px",
                                                    color: config.primaryColor,
                                                }}
                                            />
                                        ) : (
                                            <Box
                                                component={"span"}
                                                sx={{
                                                    height: "12px",
                                                    width: "12px",
                                                    ml: "8px",
                                                }}
                                            />
                                        )}
                                    </Box>
                                </Box>
                                {/* </Grid> */}
                            </MenuItem>
                        ))}
                    </>
                )}
                {/* <Divider></Divider>
                                    <MenuItem onClick={() => handleSaveMenuClose("Shortlisted")} value="Shortlisted">Shortlisted Speakers</MenuItem>
                                    <MenuItem onClick={() => handleSaveMenuClose("Rejected")} value="Rejected">Rejected Speakers</MenuItem> */}
            </Menu>
        </>
    );

    const createMarkup = (text) => {
        return { __html: text };
    };
    const MenuBtnUI = (
        <>
            {/* <Button
                id='filter-speakers1'
                aria-controls={otherOption ? "basic-menu1" : undefined}
                aria-haspopup='true'
                aria-expanded={otherOption ? "true" : undefined}
                onClick={handleOtherMenuClick}
                startIcon={
                    <MoreVertIcon
                        fontSize='small'
                        sx={{ color: config.primaryColor }}
                    />
                }
                sx={{
                    ...styles.outlinedButton,
                    height: "33.5px",
                    padding: "0",
                    minWidth: "30px",
                    marginLeft: "10px",
                    paddingLeft: "10px",
                }}
                variant='outlined'
            ></Button> */}

            <Button
                id="filter-speakers1"
                aria-controls={otherOption ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={otherOption ? "true" : undefined}
                onClick={handleOtherMenuClick}
                sx={{
                    ...styles.outlinedButton,
                    borderRadius: "8px",
                    height: "33.5px",
                    padding: "0",
                    minWidth: "30px",
                    marginLeft: "10px",
                    // paddingLeft: "10px",
                }}
                variant="outlined">
                <MoreVertIcon
                    fontSize="small"
                    sx={{
                        color: config.primaryColor,

                        transform: "rotate(90deg)",
                    }}
                />
            </Button>
            <Menu
                id="basic-menu1"
                anchorEl={otherAnchorEl}
                open={otherOption}
                onClose={() => handleOtherMenuClose("")}
                MenuListProps={{
                    "aria-labelledby": "filter-speakers1",
                }}
                sx={{
                    "& .MuiMenuItem-root:hover": {
                        background: "#F7F6FE",
                    },
                }}>
                <MenuItem onClick={() => handleOtherMenuClose("view-profile")} value="view-profile">
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                        }}>
                        <AccountCircleIcon
                            fontSize="small"
                            sx={{
                                color: config.primaryColor,
                                mr: "10px",
                            }}></AccountCircleIcon>
                        View profile
                    </Box>
                </MenuItem>
                <MenuItem onClick={() => handleOpenCommentModal()} value="leave-comment">
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                        }}>
                        <AddCommentIcon
                            fontSize="small"
                            sx={{
                                color: config.primaryColor,
                                mr: "10px",
                            }}></AddCommentIcon>
                        Leave comment
                    </Box>
                </MenuItem>
            </Menu>
        </>
    );
    const ProfilePicUI = (
        <>
            {getImageURL() && (
                <Box
                    component="img"
                    sx={{
                        objectFit: "cover",
                        width: { xs: "32px", sm: "45px" },
                        height: { xs: "32px", sm: "45px" },
                        borderRadius: "100px",
                    }}
                    src={`${getImageURL()}`}></Box>
            )}
            {!getImageURL() && (
                <Skeleton
                    variant="circular"
                    sx={{
                        width: { xs: "32px", sm: "45px" },
                        height: { xs: "32px", sm: "45px" },
                    }}
                />
            )}
        </>
    );

    const ExclusiveStatusUI = (sx = {}) => {
        return (
            <Chip
                sx={{
                    fontSize: "12px",
                    height: "25px",
                    color: "#FFFFFF",
                    background: "rgb(245, 104, 86)",

                    ...sx,
                }}
                label="WSB Exclusive"
            />
        );
    };

    const RequestFeeUI = (
        <>
            <Tooltip
                title={
                    record.brokerStatus === "No"
                        ? "Unfortunately, we don’t co-broker this speaker. Please reach out to Cristi for more information."
                        : ""
                }>
                <span>
                    <Button
                        disabled={record.brokerStatus === "No"}
                        variant="contained"
                        onClick={requestFeeModalOpenHandler}
                        sx={{
                            borderRadius: "8px",
                            padding: "4px 12px",
                            height: "33.5px",
                            marginLeft: "10px",
                            background: "#444CE7",
                            borderColor: "#2D31A6",
                        }}>
                        Request Fee
                    </Button>
                </span>
            </Tooltip>
        </>
    );

    const getSpeakerLocation = (record) => {
        let data = [];
        if (record.speakerHomeCity) {
            data.push(record.speakerHomeCity);
        }
        if (record.speakerHomeState) {
            data.push(record.speakerHomeState);
        }
        if (record.speakerHomeCountry) {
            data.push(record.speakerHomeCountry);
        }
        return data.join(", ");
    };

    const ViewDetailsUI = (
        <>
            <Button
                disabled={false}
                variant="outlined"
                onClick={() => handleOtherMenuClose("view-profile")}
                startIcon={<RemoveRedEyeOutlinedIcon />}
                className="view-details"
                sx={{
                    borderRadius: "8px",
                    padding: "4px 12px",
                    height: "33.5px",
                    marginLeft: "10px",
                    color: "#444CE7",
                    borderColor: "#CCCEFD",

                    "&:hover": {
                        borderColor: "#CCCEFD",
                    },
                }}>
                View Details
            </Button>
        </>
    );

    return (
        <>
            <Card
                sx={{
                    ...styles.card,
                    mt: "15px",
                    backgroundColor: "#fff",

                    "&:hover .view-details": {
                        display: "inline-flex",
                    },
                    "& .view-details": {
                        display: "none",
                    },
                }}>
                <CardHeader
                    sx={{
                        padding: ".5rem 1rem",
                        borderBottom: "1px solid #ededed",
                        "& .MuiCardHeader-action": {
                            margin: 0,
                        },
                    }}
                    action={
                        <Box
                            sx={{
                                height: "44px",
                                display: "flex",
                                alignItems: "center",
                                margin: "4px",
                            }}>
                            {ViewDetailsUI}
                            {SaveBtnUI}
                            {/* {MenuBtnUI} */}
                            {isBureau ? RequestFeeUI : ""}
                        </Box>
                    }
                    title={
                        <>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "start",
                                }}>
                                <Box
                                    sx={{
                                        marginRight: "1rem",
                                        display: "flex",
                                    }}>
                                    {ProfilePicUI}
                                </Box>
                                {/* <Typography sx={styles.cardHeading}>{record.name}</Typography> */}

                                <Box>
                                    <Typography
                                        fontSize={"1.1rem"}
                                        fontWeight={600}
                                        color={"#101828"}
                                        lineHeight={"1.5rem"}>
                                        {record.name}{" "}
                                        {!isBureau && (record.speakerStatus === "Exclusive" ||
                                            record.speakerStatus === "Co-Exclusive") &&
                                            ExclusiveStatusUI({
                                                display: {
                                                    xs: "none",
                                                    sm: "inline-flex",
                                                },
                                                ml: ".5rem",
                                                mr: "0.5rem",
                                            })}
                                    </Typography>
                                    {getSpeakerLocation(record) && (
                                        <Typography
                                            fontSize={"0.875rem"}
                                            fontWeight={400}
                                            color={"#475467"}
                                            lineHeight={"1.1rem"}
                                            display={"flex"}
                                            marginTop={"0.25rem"}
                                            alignItems={"center"}>
                                            <LocationOnOutlinedIcon
                                                color="brand"
                                                fontSize="small"
                                                sx={{ marginRight: "0.25rem" }}
                                            />
                                            {getSpeakerLocation(record) || ""}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        </>
                    }></CardHeader>
                <CardContent sx={{ p: 0 }}>
                    <Box
                        sx={{
                            padding: { xs: "16px", sm: "8px 20px" },
                            mb: "1rem",
                            borderRadius: "8px",
                        }}>
                        <Box sx={{ display: "flex" }} justifyContent="start">
                            <Box sx={{ width: "100%" }}>
                                <Grid container justifyContent="space-between">
                                    <Grid
                                        // lg={8}
                                        lg={7}
                                        xs={12}
                                        padding={0}
                                        pr={{ lg: "2rem" }}
                                        pb={{
                                            xs: "0.8rem",
                                            lg: "0px",
                                        }}
                                        item>
                                        {/* {getAvailability() === "BOOKED" && (
                                            <Alert sx={{ mt: "20px" }} severity="error">
                                                Confirmed conflict. Reach out to your WSB agent for further
                                                clarification.
                                            </Alert>
                                        )}

                                        {getAvailability() === "HOLD" && (
                                            <Alert sx={{ mt: "20px" }} severity="warning">
                                                Potential conflict - reach out to your WSB agent for further
                                                clarification.
                                            </Alert>
                                        )} */}

                                        {/* promotionalTitle and short bio */}
                                        {record?.promotionalTitle && (
                                            <Box
                                                component={Typography}
                                                sx={{
                                                    fontSize: "14px",
                                                    mt: "4px",
                                                    color: "#101828",
                                                    fontWeight: 500,
                                                    lineHeight: "1.25rem",
                                                }}>
                                                {/* <Typography
                                                    sx={{
                                                        color: "#344054",
                                                        fontSize: "14px",
                                                        fontWeight: 600,
                                                        // marginBottom: "8px",
                                                        marginBottom: "5px",
                                                    }}>
                                                    About
                                                </Typography> */}
                                                <Box id="a" ref={promotionalTitleNewRef}>
                                                    <TextToggle
                                                        parentRef={promotionalTitleNewRef}
                                                        text={stripHtmlTags(record.promotionalTitle)}
                                                        maxLines={2}></TextToggle>
                                                </Box>
                                            </Box>
                                        )}

                                        {record?.shortBio && (
                                            <>
                                                <Box
                                                    component={Typography}
                                                    sx={{
                                                        fontSize: "12px",
                                                        mt: "10px",
                                                        color: "#101828",
                                                        fontWeight: 400,
                                                        lineHeight: "1.25rem",
                                                    }}>
                                                    <Box id="a" ref={shortBioRef}>
                                                        <TextToggle
                                                            parentRef={shortBioRef}
                                                            text={
                                                                <div
                                                                    dangerouslySetInnerHTML={createMarkup(
                                                                        stripHtmlTags(record.shortBio)
                                                                    )}></div>
                                                            }
                                                            maxLines={2}></TextToggle>
                                                    </Box>
                                                </Box>
                                            </>
                                        )}
                                        {isBureau && (
                                            <SpeakerFeesByCity fees={record.regionFeeRanges} speaker={record} />
                                        )}
                                        {!isBureau && (record.speakerStatus === "Exclusive" ||
                                            record.speakerStatus === "Co-Exclusive") &&
                                            ExclusiveStatusUI({
                                                display: {
                                                    xs: "inline-flex",
                                                    sm: "none",
                                                },
                                                ml: "0rem",
                                                // mt: "0.5rem",
                                            })}

                                        {!isBureau && (
                                            <Box
                                                container
                                                sx={{
                                                    border: "1px solid #E0EAFF",
                                                    background: "#ECFDF3",
                                                    borderRadius: "16px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    padding: "3px 8px",
                                                    fontSize: "14px",
                                                    fontWeight: "400",
                                                    width: "fit-content",
                                                    color: "#1D2939",
                                                    my: "14px",
                                                }}>
                                                {record.feeCode ? record.feeCode : "Contact WSB"}
                                            </Box>
                                        )}

                                        <Box
                                            sx={{
                                                fontSize: "12px",
                                                my: "10px",
                                                color: "#475467",
                                            }}>
                                            {getCategory()}
                                        </Box>
                                        {(getListCount(record.Id) > 0 || getCommentCount() > 0) && (
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "start",
                                                    fontSize: "12px",
                                                }}>
                                                {getListCount(record.Id) > 0 && (
                                                    <Chip
                                                        icon={
                                                            <DvrIcon
                                                                sx={{
                                                                    fontSize: "18px",
                                                                    p: "0px 0px 0px 4px",
                                                                    height: "26px",
                                                                }}
                                                            />
                                                        }
                                                        label={
                                                            <>
                                                                {getListCount(record.Id) +
                                                                    " " +
                                                                    (getListCount(record.Id) === 1 ? "List" : " Lists")}
                                                            </>
                                                        }
                                                    />
                                                )}
                                            </Box>
                                        )}
                                        {getSpeakerAvailability()}
                                    </Grid>
                                    <Grid
                                        // lg={2}
                                        lg={5}
                                        xs={12}
                                        padding={0}
                                        item>
                                        <Box
                                            sx={{
                                                fontSize: "14px",
                                                color: "#1D2939",
                                            }}>
                                            {isBureau &&
                                                record.coBrokerCommissionStatus &&
                                                record.coBrokerProposalLanguage && (
                                                    <Box>
                                                        <Alert icon={false} severity="info" sx={{ mb: "10px" }}>
                                                            <AlertTitle sx={{ fontSize: ".8rem", fontWeight: "600" }}>
                                                                Co-Broker Information
                                                            </AlertTitle>
                                                            <Typography
                                                                ref={coBrokerProposalLanguageRef}
                                                                component={"p"}
                                                                variant="body2"
                                                                fontSize={"12px"}
                                                                fontWeight={400}
                                                                color={"#101828"}
                                                                marginTop={"5px"}>
                                                                <TextToggle
                                                                    parentRef={coBrokerProposalLanguageRef}
                                                                    text={record.coBrokerProposalLanguage}
                                                                    maxLines={5}></TextToggle>
                                                            </Typography>
                                                        </Alert>
                                                    </Box>
                                                )}
                                            <Comments
                                                speakerId={record.Id}
                                                userDetails={userDetails}
                                                comments={undefined}
                                                handleEditCommentModalOpen={handleEditCommentModalOpen}
                                                handleDeleteComment={handleDeleteComment}
                                                onOpenSpeakerModal={() => {
                                                    setSpeakerSearchSelectedTeb("Comments");
                                                    displaySpeakerScreen(record);
                                                }}
                                                inSideSpeakerCard={true}></Comments>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </Box>
                </CardContent>
            </Card>

            {/* Comment Open Modal  */}
            <Modal2
                open={openCommentModal}
                onClose={handleCloseCommentModal}
                SubmitButtonText="Add Comment"
                hideHeading={true}
                onModalSubmit={handleCommentSave}>
                <CreateComment
                    type="create"
                    commentValue={commentValue}
                    setCommentValue={setCommentValue}
                    showCommentError={showCommentError}
                    setShowCommentError={setShowCommentError}
                />
            </Modal2>

            {/* Comment Edit Modal  */}
            <Modal2
                open={editCommentModalOpen}
                onClose={handleEditCommentModalClose}
                // showDeleteButton={true}
                SubmitButtonText="Save Changes"
                hideHeading={true}
                onModalSubmit={handleSaveChangeComment}
                headingIcon={<CommentEditIcon />}
                // onDelete={handleDeleteComment}
            >
                <CreateComment
                    type="edit"
                    commentValue={commentValue}
                    setCommentValue={setCommentValue}
                    showCommentError={showCommentError}
                    setShowCommentError={setShowCommentError}
                />
            </Modal2>

            <Modal
                open={openSpeakerScreen}
                title="Speaker details"
                onClose={() => {
                    setOpenSpeakerScreen(false);
                    setSpeakerSearchSelectedTeb("");
                }}
                hideActions
                maxWidth="lg"
                removeTabIndex
                sx={{ padding: "0px" }}
                contentSx={{ overflowY: "hidden" }}
                PaperProps={{
                    sx:{
                    width:"100%"// added main container width 
                }}}>
                <Box
                    sx={{
                        height: "calc(100vh - 130px)",
                        // width: {
                        //     xs: "300px",
                        //     md: "590px",
                        //     lg: "auto",
                        // },
                    }}>
                    <Speaker
                        shared={false}
                        actionButtons={false}
                        userDetails={userDetails}
                        opportunityId={""}
                        opportunityName={""}
                        speakerId={selectedSpeaker.Id}
                        recordId={record.Id}
                        speakerRecord={{
                            speakerName: selectedSpeaker.name,
                            speakerId: selectedSpeaker.Id,
                            speakerImageURL: record?.speakerPortalImage
                                ? record?.speakerPortalImage
                                : record?.speakerImagePublicURL,
                        }}
                        feeDetails={record.feeCode ? record.feeCode : "Contact WSB"}
                        removeActions={true}
                        hideFeesTab={!isBureau}
                        bureauFeeRecords={{
                            fees: record.regionFeeRanges,
                            coBrokerCommissionStatus: record.coBrokerCommissionStatus,
                            coBrokerProposalLanguage: record.coBrokerProposalLanguage,
                        }}
                        isBureau={isBureau}
                        displayComments={true}
                        fromSpeakerSearch={true}
                        displayNotes={isBureau && record.brokeringNotes}
                        notes={record.brokeringNotes}
                        speakerSearchRecord={record}
                        speakerSearchSelectedTeb={speakerSearchSelectedTeb}
                        otherProps={{
                            handleEditCommentModalOpen,
                            handleDeleteComment,
                        }}
                        applyContainerWidth={true}></Speaker>
                </Box>
            </Modal>

            {/* Request Fees Modal */}
            {openRequestFeeModal && (
                <RequestFeeFormModal
                    openRequestFeeModal={openRequestFeeModal}
                    requestFeeModalCloseHandler={requestFeeModalCloseHandler}
                    userDetails={userDetails}
                    ProfilePicUI={ProfilePicUI}
                    record={record}
                    getSpeakerLocation={getSpeakerLocation}
                    countryPicklist={countryPicklist}
                />
            )}
        </>
    );
};

const CreateComment = ({
    handleCloseModal,
    handleSubmit,
    type = "create",
    commentValue,
    setCommentValue,
    showCommentError = "",
    setShowCommentError = () => {},
}) => {
    return (
        <Box
            minWidth={{
                xs: "100%",
                sm: 400,
            }}
            padding={"1rem 0"}>
            <Typography
                sx={{
                    color: "#101828",
                    fontSize: "18px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "144.444%", // Equivalent to 26px
                }}>
                {type === "edit" ? "Edit Comment" : "Leave Comment"}
            </Typography>
            <TextareaAutosize
                onChange={(event) => {
                    if (showCommentError) {
                        setShowCommentError("");
                    }
                    setCommentValue(event.target.value);
                }}
                value={commentValue}
                aria-label="empty textarea"
                placeholder="Type your comments"
                style={{
                    border: `1px solid ${showCommentError ? "#D14343" : "rgba(0, 0, 0, 0.08)"}`,
                    borderRadius: "8px",
                    fontSize: "14px",
                    padding: "0.5rem",
                    width: "100%",
                    minHeight: "40px",
                    marginTop: "0.5rem",
                    fontFamily: "inherit",

                    // fontStyle: "italic",
                    fontWeight: 400,
                    lineHeight: "20px", // Equivalent to 142.857%

                    maxWidth: "100%",

                    // /* Style for the placeholder text */
                    // "&::placeholder ": {
                    //     color: "red" /* Placeholder text color */,
                    //     fontStyle: "italic" /* Placeholder text style */,
                    //     opacity: 1 /* Ensure visibility (1 = fully visible) */,
                    // },
                }}
                minRows={1}

                // onKeyDown={handleKeyUp}
                // onClick={() => setDisplayLineText(true)}
                // onBlur={() => setDisplayLineText(false)}
            />
            {showCommentError && (
                <FormHelperText error sx={{ margin: "0 0 0 4px" }}>
                    {showCommentError}
                </FormHelperText>
            )}
        </Box>
    );
};

const constantFeesData = [
    {
        country: "Europe",
        fee: "$25K - $40K",
    },
    {
        country: "New York",
        fee: "$40K",
    },
    {
        country: "Africa",
        fee: "$15K - $30K",
    },
    {
        country: "Australia",
        fee: "$25K",
    },
    {
        country: "Europe",
        fee: "$25K - $40K",
    },
    {
        country: "New York",
        fee: "$40K",
    },
    {
        country: "Africa",
        fee: "$15K - $30K",
    },
    {
        country: "Australia",
        fee: "$25K",
    },
];
const SpeakerFeesByCity = ({ fees, speaker }) => {
    const [showAll, setShowAll] = useState(false);

    const valueToNumeric = (value) => {
        if (value === "$200,001 & Up") {
            return 200001;
        }
        const rangeParts = value.split(" - ");
        return parseInt(rangeParts[0].replace("$", "").replace(",", ""));
    };

    const getSpeakerFeesList = () => {
        if (fees?.length > 0) {
            let allFee = fees.sort((a, b) => {
                // Check if 'Name' contains 'Contact US'
                let aHasContactUS =
                    a.name?.toLowerCase().includes(" us ") ||
                    a.name?.toLowerCase().includes(" us") ||
                    a.name?.toLowerCase().includes("us ") ||
                    a.name?.toLowerCase().startsWith("us");
                let bHasContactUS =
                    b.name?.toLowerCase().includes(" us ") ||
                    b.name?.toLowerCase().includes(" us") ||
                    b.name?.toLowerCase().includes("us ") ||
                    b.name?.toLowerCase().startsWith("us");
                let aHasVirtual = a.name?.toLowerCase().includes("virtual");
                let bHasVirtual = b.name?.toLowerCase().includes("virtual");

                // If 'a' contains 'Contact US' and 'b' does not, 'a' should come first
                if (aHasContactUS && !bHasContactUS) return -1;
                // If 'b' contains 'Contact US' and 'a' does not, 'b' should come first
                if (!aHasContactUS && bHasContactUS) return 1;

                if (aHasVirtual && !bHasContactUS && !bHasVirtual) return -1;
                if (bHasVirtual && !aHasContactUS && !aHasVirtual) return 1;

                // If both or neither contain 'Contact US', sort alphabetically (case-insensitive)
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });

            let newList = showAll ? allFee : allFee.slice(0, 2);

            return newList || [];
        }
        return [];
    };

    const showAllListHandler = () => {
        setShowAll(true);
    };
    const showLessListHandler = () => {
        setShowAll(false);
    };

    return (
        <>
            <Divider sx={{ borderColor: "#f4f4f4", margin: "0.5rem 0" }} />
            <Box sx={{ mb: "1rem" }}>
                <Typography
                    sx={{
                        color: "#344054",
                        fontSize: "14px",
                        fontWeight: 600,
                        marginBottom: "4px",
                    }}>
                    Speaker fees{" "}
                    {/* {speaker.coBrokerCommissionStatus && (
                        <Tooltip title={speaker.coBrokerProposalLanguage}>
                            <IconButton sx={{ p: 0 }}>
                                <InfoIcon sx={{ width: "18px" }}></InfoIcon>
                            </IconButton>
                        </Tooltip>
                    )} */}
                </Typography>
                {fees?.length > 0 ? (
                    <>
                        <Box>
                            {getSpeakerFeesList()?.map((cFeesDetails, index) => (
                                <Box
                                    key={index}
                                    display={"flex"}
                                    justifyContent={"space-between"}
                                    alignItems={"center"}
                                    marginBottom={"0.25rem"}
                                    sx={{ border: "1px solid #ededed", borderRadius: "6px", padding: "4px 8px" }}>
                                    <Typography
                                        component={"span"}
                                        fontSize={"14px"}
                                        fontWeight={400}
                                        color={"#3A3A3A"}
                                        lineHeight={"20px"}>
                                        {cFeesDetails.name}
                                    </Typography>
                                    <Typography
                                        component={"span"}
                                        marginLeft={"1rem"}
                                        fontSize={"14px"}
                                        fontWeight={500}
                                        color={"#3A3A3A"}
                                        lineHeight={"24px"}>
                                        {cFeesDetails.value}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                        <Typography
                            component={"div"}
                            fontSize={"12px"}
                            fontWeight={500}
                            color={"#444CE7"}
                            lineHeight={"20px"}
                            onClick={showAll ? showLessListHandler : showAllListHandler}>
                            {showAll ? "View Less" : "View All Fee Regions"}
                        </Typography>
                    </>
                ) : (
                    <Typography fontSize={"12px"}>No fees available</Typography>
                )}
            </Box>
        </>
    );
};
